import ApiFetcher2 from './ApiFetcher2';

class StudiesApi {
  static get() {
    return ApiFetcher2.get('study-segment');
  }
}

export default StudiesApi;
